
import { FormGroup, FormControl, FormArray, Validators } from '@angular/forms';


export function getUpdateChatMessageDtoFormGroup() {
return new FormGroup({
    body: new FormControl<string | undefined>('', [Validators.required, Validators.maxLength(10000)]),
})
;
}
      